'use client'

import { useComparison } from '@/lib/comparison-context'
import { Button } from '@/components/ui/button'
import { GradientButton } from '@/components/ui/gradient-button'
import { Badge } from '@/components/ui/badge'
import { Scale, X } from 'lucide-react'
import { cn } from '@/lib/utils'

export function CompareButton() {
  const { comparedProducts, setIsComparisonOpen, clearComparison } = useComparison()

  if (comparedProducts.length === 0) {
    return null
  }

  return (
    <div className="fixed bottom-8 right-8 z-40 flex items-center gap-2">
      {/* Compare Button */}
      <GradientButton
        onClick={() => setIsComparisonOpen(true)}
        variant="blue-red"
        size="lg"
        className={cn(
          "shadow-lg hover:shadow-xl transition-all duration-300",
          "font-semibold pr-3 pl-4 py-6 rounded-full group"
        )}
      >
        <Scale className="h-5 w-5 mr-2 group-hover:scale-110 transition-transform" />
        <span className="hidden sm:inline">Compare Products</span>
        <span className="sm:hidden">Compare</span>
        <Badge 
          variant="secondary" 
          className="ml-2 bg-white text-[#518BC4] font-bold px-2 py-0.5 min-w-[24px]"
        >
          {comparedProducts.length}
        </Badge>
      </GradientButton>

      {/* Clear Button */}
      <Button
        onClick={clearComparison}
        variant="outline"
        size="icon"
        className="shadow-lg hover:shadow-xl bg-white hover:bg-red-50 border-red-200 text-red-600 hover:text-red-700 rounded-full h-12 w-12"
        title="Clear all comparisons"
      >
        <X className="h-5 w-5" />
      </Button>
    </div>
  )
}
